import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { fetchProductStartWIthFilter } from './../../redux/Products/products.actions';
import Product from './Product';
import FormSelect from './../forms/FormSelect';
import LoadMore from './../LoadMore';
import './styles.scss';

const mapState = ({ productsData }) => ({
  productsft: productsData.productsft
});

var nf = new Intl.NumberFormat();

const ProductResults = ({ e }) => {
  // const query = e.target.value;
  const dispatch = useDispatch();
  const history = useHistory();
  const { filterType, brandType } = useParams();
  const { productsft } = useSelector(mapState);

  const [categoryFilter, setCategoryFilter] = useState();
  const [brandFilter, setbrandFilter] = useState();


  const { data, queryDoc, isLastPage } = productsft;

  useEffect(() => {
    // window.scrollTo(0,0);
    dispatch(
      fetchProductStartWIthFilter({ filterType, brandType })
    )
  }, [filterType, brandType]);

  const handleFilter = (e) => {
    const nextFilter = e.target.value;
    setCategoryFilter(nextFilter);
    history.push(`/products/${nextFilter}`);
  };

  const handleFilter2 = (e) => {
    const bFilter = e.target.value;
    history.push(`/products/${categoryFilter}/${bFilter}`);
  }

  const configFilters = {
    defaultValue: filterType,
    options: [{
      name: 'Show all',
      value: ''
    }, {
      value: "homeappliances",
      name: "Home Appliances"
    }, {
      value: "television&videos",
      name: "Television & Videos"
    }, , {
      value: "audio",
      name: "Audio"
    }, {
      value: "phone",
      name: "Phone"
    }, {
      value: "laptop",
      name: "Laptop"
    }, {
      value: "phones",
      name: "Phones"
    }, {
      value: "camera&photo",
      name: "Camera & Photo"
    }, {
      value: "gaming",
      name: "Gaming"
    }, {
      value: "headphones",
      name: "Headphones"
    }, {
      value: "generators",
      name: "Generators"
    }, {
      value: "portablepower",
      name: "Portable Power"
    }, {
      value: "officefurniture",
      name: "Office Furniture"
    }, {
      value: "cooling",
      name: "Cooling"
    }, {
      value: "washer&dryer",
      name: "Washer & Dryer"
    }],
    handleChange: handleFilter
  };

  const brandFilters = {
    defaultValue: brandType,
    options: [{
      name: 'Show all',
      value: ''
    }, {
      value: "bajaj",
      name: "Bajaj"
    }, {
      value: "binatone",
      name: "Binatone"
    }, , {
      value: "g&l",
      name: "G&L"
    }, {
      value: "hisense",
      name: "Hisense"
    }, {
      value: "heirthermocool",
      name: "Heir Thermocool"
    }, {
      value: "hp",
      name: "Hp"
    }, {
      value: "infinix",
      name: "Infinix"
    },
    {
      value: "jbl",
      name: "JBL"
    }, {
      value: "kemage",
      name: "Kemage"
    }, {
      value: "kinelco",
      name: "Kinelco"
    }, {
      value: "kenstar",
      name: "Kenstar"
    }, {
      value: "lenovo",
      name: "Lenovo"
    }, {
      value: "lg",
      name: "LG"
    }, {
      value: "mummy'spride",
      name: "Mummy's Pride"
    }, {
      value: "nexus",
      name: "Nexus"
    },
    {
      name: 'Oppo',
      value: 'oppo'
    }, {
      value: "panasonic",
      name: "Panasonic"
    }, {
      value: "philips",
      name: "Philips"
    }, , {
      value: "parsun",
      name: "Parsun"
    }, {
      value: "qasa",
      name: "QASA"
    }, {
      value: "royal",
      name: "Royal"
    }, {
      value: "scanfrost",
      name: "Scanfrost"
    }, {
      value: "samsung",
      name: "Samsung"
    }, {
      value: "sumecfirman",
      name: "Sumec Firman"
    }, {
      value: "saicho",
      name: "Saicho"
    }, {
      value: "skyrun",
      name: "Skyrun"
    }, {
      value: "scanfrost",
      name: "Scanfrost"
    }, {
      value: "tornado",
      name: "Tornado"
    }, {
      value: "thermofrost",
      name: "Thermofrost"
    }, {
      value: "veronica",
      name: "Veronica"
    }, {
      value: "ultra",
      name: "Ultra"
    }],
    handleChange: handleFilter2
  };

  if (!Array.isArray(data)) {
    return (
      <div className="productsflt">
        <h1 className="head-ttl">
          Browse Products
        </h1>

        <div className="form-select">
          <FormSelect {...configFilters} />
          <FormSelect {...brandFilters} />
        </div>
      </div>
    );
  };

  if (data.length < 1) {
    return (
      <div className="productsflt">
        <h1 className="head-ttl">
          Browse Products
        </h1>

        <div className="form-select">
          <FormSelect {...configFilters} />
          <FormSelect {...brandFilters} />
        </div>

        <p>
          No search results.
        </p>
      </div>
    );
  }

  const handleLoadMore = () => {
    dispatch(
      fetchProductStartWIthFilter({
        filterType,
        brandType,
        startAfterDoc: queryDoc,
        persistProducts: data
      })
    )
  };

  const configLoadMore = {
    onLoadMoreEvt: handleLoadMore,
  };

  return (
    <div className="productsflt">

      <h1 className="head-ttl">
        Browse Products
      </h1>

      <div className="form-select">
        <div className='each-filter'>
          <span>
            Filter by Category
          </span>
          <FormSelect {...configFilters} />
        </div>
        <div className='each-filter'>
        <span>
            Filter by Brand
          </span>
          <FormSelect {...brandFilters} />
        </div>
      </div>

      <div className="productResults">
        {data.map((product, pos) => {
          const { image, pname, price } = product;
          if (!image || !pname ||
            typeof price === 'undefined') return null;

          const configProduct = {
            ...product
          };

          return (
            <Product key={pos} {...configProduct} />
          );
        })}
      </div>

      {!isLastPage && (
        <LoadMore {...configLoadMore} />
      )}

    </div>
  );
};

export default ProductResults;
